export default __webpack_public_path__ + "static/media/banner.5a0cdb93.jpeg";